import {
  blueShade,
  darkOrange,
  lighterNavy,
  orange,
  white,
} from 'common/styles/colors';
import { boxShadow } from 'common/styles/page';
import { Warning } from 'features/pick-schedule-views/components/SchedulePickWizard/styles';
import styled from 'styled-components';

export const SeasonFormWrapper = styled.form<{
  isEditing: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  box-shadow: ${boxShadow};
  margin-bottom: 20px;
  padding: 30px 13px;
  gap: 10px;
  background-color: ${props => (props.isEditing ? blueShade : 'none')};
`;

const Button = styled.button`
  border: none;
  border-radius: 4px;
  padding: 5px 15px;
`;

export const ChangeBtn = styled(Button)`
  background: ${orange};
  font-family: KanitLight;
  color: ${white};
  text-wrap: nowrap;

  :hover {
    background: ${darkOrange};
  }
`;

export const SaveBtn = styled(ChangeBtn)``;

export const CancelBtn = styled(Button)`
  background: none;
  color: ${lighterNavy};

  :hover {
    background: ${white};
  }
`;

export const FormWarning = styled(Warning)`
  max-width: 375px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  span {
    min-width: 60px;
    font-family: KanitMedium;
    font-size: 20px;
    color: ${lighterNavy};
  }
`;
